var option_webview_default = {
  "option": "uzQAZ",
  "user_choice": "WK1oA",
  "check": "DY69R",
  "image": "_53BEw",
  "input": "DC98L",
  "title": "p25YT",
  "centered": "_73nyL",
  "with_result": "pOJ1N",
  "list": "_1lF-h",
  "with_image": "eRx3l",
  "progress": "s4k9r",
  "progress_value": "ERroo",
  "label": "HQwYq",
  "cta": "aEXIm",
  "adornment_icon": "_37yDR",
  "remove": "Ep3RF",
  "removeButton": "_2ZZzo",
  "removeButtonIcon": "WHhHE",
  "overlay": "XsO0i",
  "shown": "zoUx3",
  "dark": "S--n-",
  "spinner": "M3nqy",
  "spin": "_5pmHu",
  "grid": "rD2fh"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
